import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
  Tag,
} from 'antd';
import { Cart, FilterGoldIcon, FilterIcon, Order, RedCart } from 'assets/svg';
import { MainLayout } from 'components';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import CartApi from 'apis/CartApi';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useUser } from 'contexts/User';
import { useForm } from 'antd/es/form/Form';
import PofTypeApi from 'apis/PofTypeApi';
import moment from 'moment';
import { openNotificationWithIcon } from 'utils/notification';
import handleError401 from 'utils/handleError401';
import { STATUS } from 'constants/reponseStatus';

type FixedType = 'left' | 'right' | boolean;

export default function OderCartList() {
  const history = useHistory();
  const { user } = useUser();
  const { RangePicker } = DatePicker;
  const [form] = useForm();
  const { Option } = Select;
  const [formSubmitParams, setFormSubmitParams] = useState<any>();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [departmentFilter, setDepartmentFilter] = useState<any>();
  const [cartAllocated, setCartAllocated] = useState<any>();
  const queryParam = useQueryParam();
  const [total, setTotal] = useState<number>(0);
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const [options, setOptions] = useState<boolean>(true);

  const params = {
    page: page,
    page_size: page_size,
    options: options,
    ...(formSubmitParams && formSubmitParams),
  };

  const { isLoading: getCartsLoading, mutate: refetch } = useMutation(
    ['get'],
    () => CartApi.getCartAllocated(params),
    {
      onSuccess: (response: any) => {
        if (response.status === STATUS.SUCCESS) {
          setCartAllocated(response?.data);
          setTotal(response?.total);
          if (options == true) {
            setDepartmentFilter(response?.options);
          }
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const { data: lstPofType } = useQuery(['getAll'], () =>
    PofTypeApi.getCartType()
  );
  const checkRole = (id: any) => {
    switch (user?.role[0]) {
      case 'nguoi_dat_hang':
        return history.push(`/order/tvv-view/${id}`);
      case 'cua_hang_truong':
        return history.push(`/order/cht-view/${id}`);
      default:
    }
  };

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (key == 'release_date') {
        const ranges: any = filteredData[key];
        stringifiedData['release_from'] = String(ranges[0]);
        stringifiedData['release_to'] = String(ranges[1]);
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    setFormSubmitParams(stringifiedData);
    setOptions(false);
  };

  useEffect(() => {
    setTitle('Đăng ký SP kinh doanh');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/product-register">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      { title: <a href="/product-register">Đăng ký SP kinh doanh</a> },
    ]);
    refetch();
  }, [page, page_size, formSubmitParams]);

  const convertStatus = (status: number) => {
    switch (status) {
      case 0:
        return 'Mới tạo';
      case 1:
        return 'TVV duyệt gửi CHT';
      case 2:
        return 'CHT từ Chối';
      case 3:
        return 'CHT duyệt gửi CN';
      case 4:
        return 'CN từ Chối';
      case 5:
        return 'CN duyệt gửi HS';
      case 6:
        return 'HS từ chối';
      case 7:
        return 'HS duyệt';
      default:
        return '-';
    }
  };

  const IsCartExpired = (expiration_date: any) => {
    const expiration_date_converted = new Date(expiration_date);
    const today_converted = new Date();

    if (expiration_date_converted > today_converted) {
      return false;
    } else {
      return true;
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã giỏ hàng',
      dataIndex: 'cart_code',
      width: 160,
    },
    {
      title: 'Loại giỏ hàng',
      width: 200,
      dataIndex: 'cart_type_name',
    },
    {
      title: 'Tên giỏ hàng',
      width: 350,
      // dataIndex: 'cart_name',
      render: (record) => {
        if (IsCartExpired(record?.expiration_date) == true) {
          return (
            <Row gutter={[8, 8]}>
              <Col>{record?.cart_name}</Col>
              <Col>
                <Tag color="red">
                  <strong
                    style={{
                      fontSize: '16px',
                      padding: '5px 5px',
                    }}
                  >
                    Hết hạn
                  </strong>
                </Tag>
              </Col>
            </Row>
          );
        } else {
          return record.cart_name;
        }
      },
    },
    {
      title: 'Bộ phận phát triển',
      width: 200,
      dataIndex: 'nhan_hang',
    },
    {
      title: 'Người khai báo',
      width: 200,
      dataIndex: 'created_by',
    },
    {
      title: 'Phòng ban',
      width: 110,
      dataIndex: 'phong_ban',
    },
    {
      title: 'Đơn vị phát hành',
      width: 220,
      dataIndex: 'don_vi_phat_hanh',
    },
    {
      title: 'Công ty phát hành',
      width: 160,
      dataIndex: 'cong_ty_phat_hanh',
    },
    {
      title: 'Đặt hàng theo ni',
      width: 150,
    },
    {
      title: 'Trạng thái',
      width: 150,
      render: (_: any, record: any) => {
        return convertStatus(record?.status);
      },
    },
    {
      title: 'Ngày bắt đầu',
      width: 280,
      // render: (_: any, record: any) => {
      //   return formatDate(record.release_date);
      // },
      render: (record) => {
        return record.release_date
          ? moment(record.release_date).format('DD/MM/YYYY')
          : '-';
      },
    },
    {
      title: 'Ngày hết hạn',
      width: 280,
      // render: (_: any, record: any) => {
      //   return formatDate(record.expiration_date);
      // },
      render: (record) => {
        return record.expiration_date
          ? moment(record.expiration_date).format('DD/MM/YYYY')
          : '-';
      },
    },
    {
      title: 'Cập nhật lần cuối',
      width: 250,
      // render: (record: any) => {
      //   return record.updated_at || '-';
      // },
      render: (record) => {
        return record.expiration_date
          ? moment(record.updated_at).format('DD/MM/YYYY HH:mm')
          : '-';
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 150,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          {/* <button>
            <EyeIcon />
          </button> */}
          <button
            onClick={() => {
              checkRole(record?.cart_register_id);
            }}
          >
            <Order />
          </button>
          {IsCartExpired(record?.expiration_date) == true ? (
            <button
              onClick={() => {
                openNotificationWithIcon(
                  'error',
                  'Không thể đặt hàng',
                  'Giỏ hàng đã hết hạn'
                );
              }}
            >
              <RedCart />
            </button>
          ) : (
            <button
              onClick={() => {
                history.push('/order-product-list/create', {
                  cart: record,
                });
              }}
            >
              <Cart />
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <MainLayout>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col>
          <Space>
            {/* <Button
              bgColor="bg-white"
              color="text-primary-50"
              border="border-primary-50"
            >
              <OrderHistory />
              Lịch sử đặt hàng
            </Button> */}
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
        onFinish={onFinish}
        autoComplete="off"
        size="small"
      >
        <Content style={{ padding: '12px 24px' }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item
                name="cart_code"
                label="Mã giỏ hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập mã giỏ hàng"
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item
                name="cart_name"
                label="Tên giỏ hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập tên giỏ hàng"
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item
                name="cart_type"
                label="Loại giỏ hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn loại giỏ hàng">
                  {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item
                name="department_code"
                label="Phòng ban phát hành"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  showSearch
                  size="small"
                  placeholder="Phòng ban phát hành"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {departmentFilter &&
                    departmentFilter.map((item: any) => (
                      <Option
                        key={item.department_code}
                        value={item.department_code}
                      >
                        {item.department_name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item
                name="created_by"
                label="Người khai báo"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  placeholder="Nhập email người khai báo"
                  className=""
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item
                name="release_date"
                label="Ngày phát hành"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <RangePicker
                  placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                  format={'DD/MM/YYYY'}
                  style={{ padding: '9px 16px' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={cartAllocated}
          scroll={{ x: 958 }}
          loading={getCartsLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
